import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import {bindActionCreators} from 'redux';
import {fetchReservationIfNeeded} from '@/actions/reservation';
import {setCheckoutOverlay} from '@/actions/ui';
import ContinueCheckoutBanner from '../components/ContinueCheckoutBanner';
import { triggerTransition } from '@uirouter/redux';
import ContainerProps from './ContinueCheckoutBannerContainerComponent';
import { secondsTohhmmss } from '../../helpers/time';
import { getNumItemsInCart } from 'checkout/selectors/cart';
import { isKioskMode } from 'checkout/selectors/ui';

class ContinueCheckoutBannerContainer extends Component<ContainerProps> {
    getTime = () => {
        return(secondsTohhmmss(this.props.timeRemaining));
    }
    componentWillMount = () => {
        if(JSON.parse(localStorage.getItem("confirmation")) === true) {
            return;
        }

        this.props.fetchReservationIfNeeded().catch(() => {});
    }

    render() {
        if(this.props.isCompleted === true) {
            return null;
        }

        if (this.props.isKioskMode) {
            return null;
        }

        if(this.props.overlay) {
            return null;
        }

        if(!this.props.hasReservation) {
            return null;
        }

        return(
            <ContinueCheckoutBanner showCart={this.onShowCart} amount={this.getTotalCost()} timeRemaining={this.getTime()} itemCount={this.props.itemCount} />
        )
    }

    getTotalCost = () => {
        return this.props.totalAmount.amount + this.props.totalFees;
    };

    onShowCart = () => {
        this.props.triggerTransition("cart", {token: this.props.token})
        window.scrollTo(0,0);
    }
}

const mapStateToProps = state => {
    return {
        overlay: state.ui.overlay,
        hasReservation: state.reservation.token !== "",
        isCompleted: state.reservation.isCompleted,
        token: state.reservation.token,
        totalAmount: state.reservation.total_cost,
        totalFees: state.fees.totalFees,
        itemCount: getNumItemsInCart(state),
        timeRemaining: state.reservation.time_remaining,
        isKioskMode: isKioskMode(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        setCheckoutOverlay,
        fetchReservationIfNeeded,
        triggerTransition
    }, dispatch);
}

ContinueCheckoutBannerContainer.propTypes = {
    overlay: PropTypes.bool.isRequired,
    hasReservation: PropTypes.bool.isRequired,
    token: PropTypes.string.isRequired,
    totalAmount: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(ContinueCheckoutBannerContainer)
